import { ThemeEvents } from '@theme/events';

class CartIcon extends HTMLElement {
  constructor() {
    super();

    this.cartCount = null;
    this.refreshTimer = null;
    this.animation = null;
    this.requestNumber = 0;

    this.clickHandler = this.handleClick.bind(this);
    this.cartUpdatedHandler = this.scheduleRefresh.bind(this);
    this.customAddHandler = this.scheduleRefresh.bind(this);
    this.focusHandler = this.scheduleRefresh.bind(this);
  }

  connectedCallback() {
    this.cartCount = this.querySelector('[data-ref="cart-count"]');

    this.addEventListener('click', this.clickHandler);

    document.addEventListener(
      ThemeEvents.cartUpdated,
      this.cartUpdatedHandler
    );

    document.addEventListener(
      'calme:cart-added',
      this.customAddHandler
    );

    window.addEventListener('focus', this.focusHandler);

    this.refreshCount(false);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.clickHandler);

    document.removeEventListener(
      ThemeEvents.cartUpdated,
      this.cartUpdatedHandler
    );

    document.removeEventListener(
      'calme:cart-added',
      this.customAddHandler
    );

    window.removeEventListener('focus', this.focusHandler);

    clearTimeout(this.refreshTimer);
    this.requestNumber++;

    if (this.animation) {
      this.animation.cancel();
    }
  }

  getCurrentItemCount() {
    return parseInt(this.cartCount?.textContent, 10) || 0;
  }

  setCount(count, animate = true) {
    if (!this.cartCount || !Number.isFinite(count)) return;

    const previousCount = this.getCurrentItemCount();

    this.cartCount.textContent = String(count);

    const bubble = this.querySelector(
      '.header__icon-count-bubble'
    );

    if (bubble) {
      bubble.classList.toggle(
        'header__icon-count-bubble--long',
        count >= 100
      );
    }

    if (animate && count > previousCount) {
      this.animateCart();
    }
  }

  animateCart() {
    if (
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {
      return;
    }

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.animate(
      [
        { transform: 'scale(1)' },
        { transform: 'scale(1.18)' },
        { transform: 'scale(1)' }
      ],
      {
        duration: 350,
        easing: 'ease-out'
      }
    );
  }

  scheduleRefresh() {
    clearTimeout(this.refreshTimer);

    this.refreshTimer = setTimeout(() => {
      this.refreshCount(true);
    }, 100);
  }

  async refreshCount(animate = true) {
    const requestNumber = ++this.requestNumber;
    const root = window.Shopify?.routes?.root || '/';

    try {
      const response = await fetch(root + 'cart.js', {
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      });

      if (!response.ok) return;

      const cart = await response.json();

      if (
        !this.isConnected ||
        requestNumber !== this.requestNumber
      ) {
        return;
      }

      this.setCount(cart.item_count, animate);
    } catch (error) {
      console.warn(
        'Actualisation du compteur indisponible.',
        error
      );
    }
  }

  handleClick() {
    const cartDrawer = document.querySelector(
      '[data-ref="cart-drawer"]'
    );

    if (cartDrawer) {
      cartDrawer.open();
    } else {
      window.location.href =
        window.Theme?.routes?.cart_url ||
        (window.Shopify?.routes?.root || '/') + 'cart';
    }
  }
}

if (!customElements.get('cart-icon')) {
  customElements.define('cart-icon', CartIcon);
}
